module.exports = __webpack_public_path__ + "img/success.2a1dfcad.png";